import LandingSection from 'components/landing/components/landing-section';
import NoteListSection from 'components/landing/selected-note-list/note-list-section';
import PropTypes from 'prop-types';
import SearchBox from 'components/landing/selected-note-list/search-box';
import SearchResultSection from 'components/landing/selected-note-list/search-result-section';
import useSearchState from 'hooks/useSearchState';

const SelectedNoteList = ({ pageCode, title }) => {
    const searchState = useSearchState();

    return (
        <>
            <SearchBox
                pageCode={pageCode}
                title={title}
                searchState={searchState}
            />
            <LandingSection>
                {/* Search Results Section */}
                <SearchResultSection
                    pageCode={pageCode}
                    searchState={searchState}
                />

                {/* Main Note List Section */}
                <NoteListSection
                    pageCode={pageCode}
                    activeSearch={searchState.activeSearch}
                />
            </LandingSection>
        </>
    );
};

SelectedNoteList.propTypes = {
    pageCode: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
};

export default SelectedNoteList;
